import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listWeatherForecastPoints } from '@ebalance/proto/bffuser/v1/weather_forecast_point_service-WeatherForecastPointService_connectquery'
import {
  ListWeatherForecastPointsRequestSchema,
  type ListWeatherForecastPointsResponse,
} from '@ebalance/proto/bffuser/v1/weather_forecast_point_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 全 10 エリアの気象予測地点設定と候補一覧を取得する。
 *
 * options.throwOnError = false で呼ぶと fetch 失敗をページ全体の error boundary
 * に投げず data=undefined で degrade する (auxiliary 用途向け、例: 需要想定画面の
 * 一時切替 UI)。既定は global QueryClient 準拠 (admin 画面等の core data 用途)。
 */
export function useListWeatherForecastPoints(options?: {
  throwOnError?: boolean
}): UseQueryResult<ListWeatherForecastPointsResponse, ConnectError> {
  return useQuery(
    listWeatherForecastPoints,
    create(ListWeatherForecastPointsRequestSchema, {}),
    options?.throwOnError !== undefined
      ? { throwOnError: options.throwOnError }
      : undefined,
  )
}
